import React, { useState, useEffect } from "react";
import { Col, Row, Table, Form  } from "react-bootstrap";
import api from "../../service/api";
import Input from "../Input/index";
import DateRangePicker from "../DateRangePicker";
import PageSelector from "../PageSelector";
import {
  Main,
  ButtonGroupCol,
  PeriodButton,
  PeriodButtonText,
  FilterTitle,
  FilterDateAndButtonsContainer,
  FilterDateConteiner,
  PeriodButtonsContainer,
  Container,
  Button
} from "./styles";
import { Props } from "./interfaces";
//Assets
import search from "../../assets/icons/search.svg";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import Select from "../Select";
import { ToastContainer } from "react-toastify";

const TableCustom = ({
  children,
  maximumPage,
  page,
  setPage,
  arrayForSelect,
  buttonText,
  endDate,
  filter,
  filterGraficButton,
  handleExport,
  id,
  isAddFormVisible,
  isButtonDisabled,
  nonFilterable,
  searchAndFilter,
  searchTerm,
  setEndDate,
  setFilterGraficButton,
  setIsAddFormVisible,
  setSearchTerm,
  setStartDate,
  setTypeSearch,
  showAddButton,
  showExportButton,
  startDate
}: Props) => {

  const [debouncedCampaignName, setDebouncedCampaignName] = useState("");
  const [campaign, setCampaign] = useState({
    description: "",
  });

  const [searchType, setSearchType] = useState<string>()
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  const [buyer, setBuyer] = useState({
    firstName: "",
  });
  const [debouncedBuyerName, setDebouncedBuyerName] = useState("");

  const [searchDataResult, setSearchDataResult] = useState<Array<any>>([])

  const login = useSelector((state: {login: any}) => state.login);

  useEffect(() => {
    const timerId = setTimeout(() => {
        setDebouncedBuyerName(buyer.firstName);
    }, 300);
    
    return () => {
        clearTimeout(timerId);
    }
}, [buyer.firstName]);


  useEffect(() => {
    const getBuyersAtApi = async () => {
      const {data} = await api.get("/buyer/list", {
          params: {
              branchsId: login.user.branchsId,
              search: debouncedBuyerName,
          }
      });
      
      setSearchDataResult(data.Buyer)
    }
  
    if(debouncedBuyerName !== ""){
      getBuyersAtApi();
    }
}, [debouncedBuyerName]);

  useEffect(() => {
    const timerId = setTimeout(() => {
        setDebouncedCampaignName(campaign.description);
    }, 300);
    
    return () => {
        clearTimeout(timerId);
    }
  }, [campaign.description]);

  useEffect(() => {
    const getCampaignsAtApi = async () => {
      const { data } = await api.get("donations/camp/list", {
          params: {
              sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
              search: debouncedCampaignName,
          }
      });
      
      setSearchDataResult(data.donationsCamp)
    }
    
    if(debouncedCampaignName !== ""){
      getCampaignsAtApi();
    }
}, [debouncedCampaignName]);

  const isAddButtonVisible = () => {
    if(showAddButton){
      return buttonText ? <Button id={`add-button-${id}`} onClick={() => setIsAddFormVisible ? setIsAddFormVisible(true) : null}>{buttonText}</Button> : null
    }
  }

  const isExportButtonVisible = () => {
    if(showExportButton){
      return <Button id={`export-button-${id}`} outline={true} disabled={isButtonDisabled} 
      onClick={
        () => {
          if(handleExport){
            handleExport()
          } 
          
          else { null }
        }
      }>Exportar Dados</Button>
    }
  }
  const handleKeyPress = (event: any) => {
    if(event.key === "Enter"){
      event.preventDefault()
    }
  }

  const dataForTypeSearch = {
    name: {
      label: "Nome",
      value: "name"
    },
    status: {
      label: "Status",
      value: "status"
    },
    campanha: {
      label: "Campanha",
      value: "campanha"
    },
  }

  return (
    <Main 
      className="mb-5" 
      layout
      transition={{    
      }}
      id={id}
      searchAndFilter={searchAndFilter}
    >
      <ToastContainer/>
      <Row
        style={{ paddingTop: "1rem", paddingBottom: "1rem", marginTop: 29.5 }}
        as={motion.div}
        layout
      >
        {
          nonFilterable === true ? null : (
            <Col lg={filter ? "9" : "4"} md={filter ? "9": "5"}  className="d-flex align-items-center">
              <Form style={{ marginLeft: 13, marginRight: 13 }} className="w-100 h-auto d-flex align-items-center" id={`filter-${id}`}>
                {filter === true ?
                    searchAndFilter === true ? 
                      <Container>
                        <Form.Group controlId="search" className="inputWithIcon">
                          <Select 
                            defaultValue={searchType}
                            onChange={(e: any) => {
                              setSearchType(e.target.value)
                              setTypeSearch ? setTypeSearch(e.target.value): null }}
                            style={{
                              width: 120, borderTopRightRadius: 0,
                              borderBottomRightRadius: 0}}
                          >
                            <option value="" selected disabled hidden>Selecionar</option>
                            {
                              arrayForSelect?.map((item) => {
                                return (
                                  <option value={item}>
                                    { dataForTypeSearch[item as keyof typeof dataForTypeSearch].label }
                                  </option>
                                )
                              })
                            }
                          </Select>
                          <Input
                            style={{borderTopLeftRadius: 0,
                              borderBottomLeftRadius: 0,}}
                            className="inputCustom"
                            placeholder="Buscar"
                            isSearchField={true}
                            searchTrasitionTable={true}
                            setValue={setSearchTerm}
                            searchType={dataForTypeSearch[searchType as keyof typeof dataForTypeSearch]?.value}
                            value={searchTerm}
                            searchResults={searchDataResult}
                            onChange={(e: any) => {
                              if(arrayForSelect?.indexOf("campanha") !== -1){
                                setCampaign(
                                  {description: e.target.value}
                                )
                              }else if (arrayForSelect?.indexOf("name") !== -1) {
                                setBuyer(
                                  {firstName: e.target.value}
                                )
                              }
                              setSearchTerm ? setSearchTerm(e.target.value): null
                            }}
                          />                          
                          {/* <img id="tableformimg" src={search} alt="Procurar"/> */}
                          
                        </Form.Group>
                        <FilterDateAndButtonsContainer>
                          <FilterDateConteiner>
                            <FilterTitle>Filtro:</FilterTitle>
                            <DateRangePicker 
                              isDisabled={filterGraficButton === 0}
                              startDate={startDate}
                              setStartDate={setStartDate}
                              endDate={endDate}
                              setEndDate={setEndDate}
                            />
                          </FilterDateConteiner>
                          <PeriodButtonsContainer>
                            <PeriodButton isActive={filterGraficButton === 0} onClick={() => setFilterGraficButton ? setFilterGraficButton(0): null}><PeriodButtonText>Período</PeriodButtonText></PeriodButton>
                            <PeriodButton isActive={filterGraficButton === 2} onClick={() => setFilterGraficButton ? setFilterGraficButton(2): null}><PeriodButtonText>Semana</PeriodButtonText></PeriodButton>
                            <PeriodButton isActive={filterGraficButton === 1} onClick={() => setFilterGraficButton ? setFilterGraficButton(1): null}><PeriodButtonText>Mês</PeriodButtonText></PeriodButton>
                          </PeriodButtonsContainer>
                        </FilterDateAndButtonsContainer>
                      </Container>
                      :
                      <FilterDateAndButtonsContainer>
                        <FilterDateConteiner>
                          <FilterTitle>Filtro:</FilterTitle>
                          <DateRangePicker 
                            isDisabled={filterGraficButton === 0}
                            startDate={startDate}
                            setStartDate={setStartDate}
                            endDate={endDate}
                            setEndDate={setEndDate}
                          />
                        </FilterDateConteiner>
                        <PeriodButtonsContainer>
                          <PeriodButton isActive={filterGraficButton === 0} onClick={() => setFilterGraficButton ? setFilterGraficButton(0): null}><PeriodButtonText>Período</PeriodButtonText></PeriodButton>
                          <PeriodButton isActive={filterGraficButton === 2} onClick={() => setFilterGraficButton ? setFilterGraficButton(2): null}><PeriodButtonText>Semana</PeriodButtonText></PeriodButton>
                          <PeriodButton isActive={filterGraficButton === 1} onClick={() => setFilterGraficButton ? setFilterGraficButton(1): null}><PeriodButtonText>Mês</PeriodButtonText></PeriodButton>
                        </PeriodButtonsContainer>
                      </FilterDateAndButtonsContainer>
                    : 
                  <Form.Group controlId="search" className="inputWithIcon" onKeyPress={handleKeyPress}>
                    <Input id="tableform" type="text" placeholder="Buscar" value={searchTerm} onChange={(e) => setSearchTerm ? setSearchTerm(e.target.value): null} />
                    <img id="tableformimg" src={search} alt="Procurar"/>
                  </Form.Group>
                }
              </Form>
            </Col>
          )
        }

        <ButtonGroupCol id="container-export-button" className={filter ? "col col-sm-4 col-md-3 col-lg-3" : `col col-12 col-md-7 ${nonFilterable ? "col-lg-12" : "col-lg-8"}`}>
            {isAddButtonVisible()}
            {isExportButtonVisible()}
        </ButtonGroupCol> 
      </Row>

      <Row as={motion.div} layout>
        <Col>
          <Table striped responsive>
            {children}
          </Table>
        </Col>
      </Row>
      <PageSelector
        page={page}
        setPage={setPage}
        maxPage={maximumPage}
      />
    </Main>
  );
};

export default TableCustom;
